/**
 * This gets overriden in app to use local storage instead
 */
export class MemoryLastCodeVerifierProvider {
    last_code_verifier?: string;

    store = ({ code_verifier }: { code_verifier: string }) => {
        this.last_code_verifier = code_verifier;
    }
    getLastVerifier = (): { code_verifier?: string } => {
        return { code_verifier: this.last_code_verifier };
    }
}
